import styles from "../Help/Help.module.scss";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import Srcset from "@/components/common/Srcset";
import { useDispatch } from "react-redux";
import { showPwaLoader } from "@/redux/actions/pwaAction";
import { openHelpSidebar } from "@/redux/actions/helpAction";
import Link from "next/link";
import { generalConstants } from "@/utils/constants";

export default function Help(props) {
  const dispatch = useDispatch();
  const [userName, setUserName] = useState('');
  const logedIn = useSelector((state) => state.loginUser);

  const showChat = () => {
    // Invoke Kustomer chat
    // if(typeof window !== undefined && window?.parent?.Kustomer) {
    //   window?.parent?.Kustomer?.open()
    // }

    // if (typeof document !== undefined && document.getElementById("kustomer-ui-sdk-iframe")) {
    //   const iFrame = document.getElementById("kustomer-ui-sdk-iframe")
    //   // targeting the contents
    //   const innerDoc = iFrame.contentDocument || iFrame.contentWindow.document
    //   if (innerDoc.querySelector("#rootChatIcon")) {
    //     innerDoc.querySelector("#rootChatIcon").click();
    //   }
    // } 

    // if (typeof document !== undefined && document.getElementById("kustomer-ui-sdk-iframe")) {
    //   let iframe = document.getElementById("kustomer-ui-sdk-iframe")
    //   if(iframe?.contentWindow?.document?.getElementsByTagName("DIV")["rootChatIcon"]){
    //     iframe?.contentWindow?.document?.getElementsByTagName("DIV")["rootChatIcon"]?.click()
    //   }
    // }
  }
  
  useEffect(() => {
    if (logedIn.userLoggedIn) {
      setUserName(` ${logedIn?.userData?.firstName}`);
    } else {
      setUserName('')
    }
  }, [logedIn]);

  const isPWA = useSelector((state) => state.pwa.is_PWA);

  return (

    <div className={styles.help_contents}>
      <div className={styles.help_back}>
        <a
          onClick={() => {
            if (props.activeTab) {
              props.activeTab("");
            }
            dispatch(openHelpSidebar(false));
          }}
        >
          <Srcset
            requirePath={true}
            svgFile={true}
            src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
            alt="back button"
            height="11.31"
            width="11.31"
          />
        </a>
      </div>
      <div
        className=""
      >
        <div
          className={`${styles.heading}`}
        >
          <div
            className={`x-large-xs light`}
          >
            {`Hi${userName}, how can we help you?`}
          </div>
        </div>
        <div>
          <p className={`x-small-xs ${styles.sub_heading}`}>
            Our customer care team is available from <br/> Monday - Friday 8am - 4pm EST
          </p>
        </div>
        <div>
          <ul>
            {/* <li>
              <div className={styles.chat_section}>
                <div>
                  <Srcset
                    requirePath={true}
                    svgFile={true}
                    src={"images/Text.svg?imbypass=true"}
                    alt="Chat icon"
                    height="19"
                    width="19"
                    className={`${isPWA ? "app_ga_help_chat" : ""}`}
                  />
                </div>
                <div>
                  <span className={`${isPWA ? "app_ga_help_tracking" : ""}`} onClick={() => {
                    showChat()
                  }}>Chat</span>
                </div>
              </div>
            </li> */}
            <li>
              <a id="email-care" className="exclude-pwa-loader">
                <div className={styles.email_section}>
                  <div>
                    <Srcset
                      requirePath={true}
                      svgFile={true}
                      src={"images/Message.svg?imbypass=true"}
                      alt="Email icon"
                      height="14"
                      width="19"
                      className={`${isPWA ? "app_ga_help_email" : ""}`}
                    />
                  </div>
                  <Link href={`mailto:${generalConstants.help_email}`} className="exclude-pwa-loader">
                    <div>
                      <span className={`${isPWA ? "app_ga_help_tracking" : ""}`}>Email</span>
                    </div>
                  </Link>
                </div>
              </a>
            </li>
            {/* <li>
              <a
                id="no"
                href="tel:+18554542978"
                className="exclude-pwa-loader"
              >
                <div className={styles.call_section}>
                  <div>
                    <Srcset
                      requirePath={true}
                      svgFile={true}
                      src={"images/Phone.svg?imbypass=true"}
                      alt="phone icon"
                      height="17"
                      width="17"
                      className={`${isPWA ? "app_ga_help_call" : ""}`}
                    />
                  </div>
                  <div>
                    <span className={`${isPWA ? "app_ga_help_tracking" : ""}`}>Call</span>
                  </div>
                </div>
              </a>
            </li> */}
            <li>
              <a href="/faq" onClick={() => { dispatch(showPwaLoader(true)) }}>
                <div className={styles.faq_section}>
                  <div>
                    <Srcset
                      requirePath={true}
                      svgFile={true}
                      src={"images/Questionmark.svg?imbypass=true"}
                      alt="faq icon"
                      height="15"
                      width="17"
                      className={`${isPWA ? "app_ga_help_faq" : ""}`}
                    />
                  </div>
                  <div>
                    <span className={`${isPWA ? "app_ga_help_tracking" : ""}`}>FAQs</span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="/jewelry-concierge" onClick={() => { dispatch(showPwaLoader(true)) }}>
                <div className={styles.jewel_section}>
                  <div>
                    <Srcset
                      requirePath={true}
                      svgFile={true}
                      src={"images/Gem.svg?imbypass=true"}
                      alt="jewel icon"
                      height="14"
                      width="18"
                      className={`${isPWA ? "app_ga_help_jewelry" : ""}`}
                    />
                  </div>
                  <div>
                    <span className={`${isPWA ? "app_ga_help_tracking" : ""}`}>Jewelry concierge</span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="/personal-shopping" onClick={() => { dispatch(showPwaLoader(true)) }}>
                <div className={styles.shop_section}>
                  <div>
                    <Srcset
                      requirePath={true}
                      svgFile={true}
                      src={"images/Shoppingbag.svg?imbypass=true"}
                      alt="shopping icon"
                      height="16"
                      width="17"
                      className={`${isPWA ? "app_ga_help_shopping" : ""}`}
                    />
                  </div>
                  <div>
                    <span className={`${isPWA ? "app_ga_help_tracking" : ""}`}>Personal shopping</span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div className={styles.help_footer_section}>
          <ul>
            <li className={styles.legal_section}>
              <a href="/legal" onClick={() => { dispatch(showPwaLoader(true)) }}>
                <span className={`${isPWA ? "app_ga_help_tracking" : ""}`}>
                  Legal
                </span>
              </a>
            </li>
            <li className={styles.privacy_section}>
              <a href="/privacy" onClick={() => { dispatch(showPwaLoader(true)) }}>
                <span className={`${isPWA ? "app_ga_help_tracking" : ""}`}>
                  Privacy policy
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
